<script lang="ts">
    import { onMount } from 'svelte/internal'
    import Zinput from '../../_common/z/zinput.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import Zframe from '../../_common/z/zframe.svelte'

    export let reportId: string
    export let params: Record<string, any> = {}

    const localeOptions = [
        { value: 'pt-BR', label: 'Português (Brasil)' },
        { value: 'en-US', label: 'Internacional (Notion, Zapier, Excel em inglês...)' },
    ]

    let show = true
    let csvUrl = ''
    let importFormula = ''
    let error = ''
    let locale: 'pt-BR' | 'en-US' = 'pt-BR'

    onMount(loadLink)

    async function loadLink() {
        try {
            show = true
            error = ''
            const result = await window.api.reports.catalog.createExportToken(reportId, params, locale)
            // shortUrl (link.zandu.com.br/link/<token>) redireciona pro CSV direto — reportId/params/locale
            // já vêm embutidos no token (ver ReportsExportTokenController.buildCsvRedirectUrl). Fallback
            // pra URL longa só se por algum motivo o backend não devolver shortUrl.
            csvUrl = result.shortUrl || window.api.reports.catalog.buildCsvUrl(reportId, { ...params, locale }, result.token)
            // O delimitador do CSV (2º parâmetro) e a localidade (3º) sempre acompanham o formato real do
            // arquivo — nunca omitidos, pra o Sheets nunca precisar "adivinhar" com base no locale da
            // própria planilha. O separador de ARGUMENTOS da fórmula em si fica sempre ";" (assume
            // planilha em pt-BR, o caso comum aqui) — isso é sintaxe da fórmula, não formato do dado.
            const csvDelimiter = locale === 'pt-BR' ? ';' : ','
            const sheetsLocale = locale === 'pt-BR' ? 'pt_BR' : 'en_US'
            importFormula = '=IMPORTDATA("' + csvUrl + '"; "' + csvDelimiter + '"; "' + sheetsLocale + '")'
        } catch (err) {
            window.error(err)
            error = 'Não foi possível gerar o link agora. Tente novamente em instantes.'
        } finally {
            show = false
        }
    }
</script>

<div class="root">
    <Zframe title="Link de Integração">
        {#if error}
            <div class="alert alert-danger">{error}</div>
        {:else}
            <div class="intro-label mb-3">Este link permite que você acesse seus dados de outras ferramentas, como Excel e Google Sheets.</div>
            <div class="intro-label mb-3">
                O link reflete o período e os filtros selecionados na tela atual. Caso mude os filtros, gere outro link.<br />
                Este link é "ao vivo". Mudanças nos dados refletirão na ferramenta externa.<br />
                Google Sheets: Cole a fórmula abaixo direto numa célula do Google Sheets. A fórmula assume que sua planilha está em
                Português — se estiver em outro idioma e a fórmula der erro, troque os ";" por ",".<br />
                Excel: use "Dados" → "Obter dados da Web" com o link CSV.<br />
                Notion e outras ferramentas internacionais: troque "Formato dos números" pra Internacional abaixo, e use o link CSV
                direto.<br />
                Importante: qualquer pessoa com acesso a este link terá acesso ao conteúdo.
            </div>
            <Zinput type="select" label="Formato dos números" options={localeOptions} bind:value={locale} on:change={loadLink} />
            {#if !show}
                <Zinput class="mt-3" disabled={true} label="Link CSV" value={csvUrl} showCopy={true} />
                <Zinput class="mt-3" disabled={true} label="Fórmula para o Google Sheets" type="text" value={importFormula} showCopy={true} />
            {/if}
        {/if}
        <LoadSpinner {show} />
    </Zframe>
</div>

<style>
    .root {
        position: relative;
        min-height: 140px;
    }
    .intro-label {
        opacity: 0.8;
        font-weight: 300;
        font-size: 14px;
    }
</style>
